import siteData from './site-data';
import publishedSiteData from './published-site-data';
import siteReset from './site-reset';

export default {
  siteData,
  publishedSiteData,
  siteReset,
};
